import '../css/CareersPageComponent.scss';
import BannerComponent from './BannerComponent';
import CareerImage from '../assets/carrer.jpeg';
import { FiBookOpen, FiHeart, FiAward, FiUsers, FiZap, FiStar, FiMail } from 'react-icons/fi';

const openRoles = [
  {
    title: 'Primary School Teachers',
    type: 'Year 1 – 6',
    description:
      'Deliver engaging, high-quality lessons across the primary curriculum to pupils in Years 1–6, maintaining the highest academic standards in a nurturing classroom environment.',
  },
  {
    title: 'Preschool Teachers',
    type: 'EYFS',
    description:
      'Provide a warm, stimulating early-years experience for our youngest learners, following the EYFS framework and fostering curiosity, play and foundational skills.',
  },
  {
    title: 'Subject Specialists',
    type: 'Yoruba & English',
    description:
      'Teach Yoruba and/or English as specialist subjects, bringing deep subject knowledge and a passion for language, literacy and cultural appreciation.',
  },
];

const whyUs = [
  { icon: <FiHeart />, text: 'Inspire a love for learning' },
  { icon: <FiBookOpen />, text: 'Grow professionally through continuous development' },
  { icon: <FiUsers />, text: 'Teach in an inclusive and child-centred environment' },
  { icon: <FiZap />, text: 'Collaborate with innovative and supportive colleagues' },
  { icon: <FiStar />, text: "Make a lasting impact in children's lives" },
];

const benefits = [
  'Competitive salary',
  'Professional development opportunities',
  'Supportive leadership',
  'Career growth pathways',
  'Inclusive work environment',
  'Recognition and staff appreciation initiatives',
  'Modern teaching resources',
];

const CareersPageComponent = () => (
  <div>
    <BannerComponent
      title="Careers at HoneyRock"
      image={CareerImage}
      description="Join a team of passionate educators dedicated to shaping tomorrow's leaders."
      buttonInformation={<></>}
    />

    <div className="page-width">

      {/* Intro */}
      <section className="careers-intro">
        <span className="careers-section-kicker">Join Our Team</span>
        <h2>Build More Than a Career — Build a Community</h2>
        <p>
          At The HoneyRock Nursery &amp; Primary School, we don't just employ staff — we build a
          community of passionate professionals dedicated to shaping the future.
        </p>
        <p>
          If you believe every child deserves to be seen, heard, challenged, and inspired, we'd love
          to meet you.
        </p>
        <p>
          Become part of a school where every child can thrive, and every educator can grow.
        </p>
        <a href="mailto:career@thehoneyrockschool.com" className="careers-teaser-btn">
          Apply Today
        </a>
      </section>

      {/* Why Work With Us */}
      <section className="careers-why">
        <div className="careers-why-text">
          <span className="careers-section-kicker">Why Work With Us?</span>
          <h2>Great Schools Are Built by Exceptional People</h2>
          <p>At HoneyRock, we believe great schools are built by exceptional people.</p>
          <p>We provide an environment where educators are empowered to:</p>
          <ul className="careers-why-list">
            {whyUs.map(item => (
              <li key={item.text}>
                <span className="why-icon">{item.icon}</span>
                {item.text}
              </li>
            ))}
          </ul>
        </div>

        {/* Benefits */}
        <div className="careers-benefits">
          <span className="careers-section-kicker">Employee Benefits</span>
          <h2>A Great Workplace for Great Teachers</h2>
          <p>We believe great teachers deserve a great workplace. Eligible staff enjoy:</p>
          <ul className="benefits-list">
            {benefits.map(b => (
              <li key={b}>{b}</li>
            ))}
          </ul>
        </div>
      </section>

      {/* Open roles */}
      <section className="careers-roles">
        <span className="careers-section-kicker">Current Openings</span>
        <h2>Available Positions</h2>
        <p className="careers-roles-sub">
          All applicants must meet the following requirements: minimum NCE / Bachelor's degree in
          Education or a related field; proven experience with the Nigeria / British Curriculum;
          strong communication skills and teaching pedagogy; classroom management skills; and a
          passion for child development and inclusive education.
        </p>

        <div className="roles-grid">
          {openRoles.map(role => (
            <div key={role.title} className="role-card">
              <div className="role-card-top">
                <h3>{role.title}</h3>
                <span className="role-type">{role.type}</span>
              </div>
              <p>{role.description}</p>
              <a
                href="mailto:career@thehoneyrockschool.com?subject=Job Application"
                className="role-apply-btn"
              >
                Apply Now
              </a>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="careers-cta">
        <FiMail className="cta-icon" />
        <h2>Ready to Join Us?</h2>
        <p>
          Send your CV and a short cover letter to us and we'll be in touch.
        </p>
        <a
          href="mailto:career@thehoneyrockschool.com?subject=Job Application"
          className="careers-teaser-btn"
        >
          career@thehoneyrockschool.com
        </a>
      </section>

    </div>
  </div>
);

export default CareersPageComponent;
